import { FETCH_MASTER_OUTBOUND_LIST, RECEIVE_MASTER_OUTBOUND_LIST, FAILED_MASTER_OUTBOUND_LIST } from '../actions/stck.masteroutboundwithItem.act'

const defaultStckMasterOutboundState = {
    stckMasterOutboundData: [],
    stckTotalMasterOutboundItem: 0,
    stckMasterOutboundItem: [],
    success: true,
    inProgress: false,
}

export function StckMasterOutbound(state = defaultStckMasterOutboundState, action){
    switch (action.type) {
        case FETCH_MASTER_OUTBOUND_LIST:
            return ({stckMasterOutboundData: [], success: true, stckTotalMasterOutboundItem: 0, 
                                            stckMasterOutboundItem: [], inProgress: true})
        case RECEIVE_MASTER_OUTBOUND_LIST:
            var _totalMasterOutbound = action.payloadOfOutboundItem.result.length
            return Object.assign({}, state, {stckMasterOutboundData: action.payloadOfMasterOutbound, success: true, stckTotalMasterOutboundItem: _totalMasterOutbound, 
                                                                    stckMasterOutboundItem: action.payloadOfOutboundItem, inProgress: false})
        case FAILED_MASTER_OUTBOUND_LIST:
            return ({stckMasterOutboundData: [], success: false, stckTotalMasterOutboundItem: 0,
                                                     stckMasterOutboundItem: [], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/stck.masteroutboundwithItem.red.js